import { render, staticRenderFns } from "./aftersalevideo_edit.vue?vue&type=template&id=9337866c&scoped=true"
import script from "./aftersalevideo_edit.vue?vue&type=script&lang=js"
export * from "./aftersalevideo_edit.vue?vue&type=script&lang=js"
import style0 from "./aftersalevideo_edit.vue?vue&type=style&index=0&id=9337866c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9337866c",
  null
  
)

export default component.exports